/*
 * zeroLabs: Kopf und Menü. Verhalten des Menüs am Handy (Fläche über dem Bildschirm) und der Flächen
 * unter dem Kopf am Desktop. Inhalt: snippets/zl-kopf-eintraege.liquid, Gestaltung: assets/zl-kopf.css,
 * Werte: assets/zl-tokens.css. Warenkorb und Konto laufen über die Elemente des Themes, die Länderwahl steht im Fuß.
 */
(() => {
  const html = document.documentElement;
  const ruhig = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // Menü als Fläche bis 1024, darüber die Einträge im Kopf (zl-kopf.css)
  const handy = () => !window.matchMedia('(min-width: 1025px)').matches; // token-ok: Bruchstelle des Themes
  // Zeiten und Maße aus zl-tokens.css. Shopify verkleinert die CSS-Datei und schreibt 240ms dabei als .24s.
  const ms = (name) => {
    const wert = getComputedStyle(html).getPropertyValue(name).trim();
    const zahl = parseFloat(wert) || 0;
    return /\ds$/.test(wert) && !/ms$/.test(wert) ? zahl * 1000 : zahl;
  };
  // Dieselben Werte, einmal gelesen: Im Moment des Tippens soll der Browser nichts neu berechnen müssen, nur um einen Wert zu lesen
  const fest = {};
  const tok = (name) => (name in fest ? fest[name] : (fest[name] = ms(name)));
  const kopf = () => document.querySelector('.header-wrapper');
  const kopfUnten = () => { const k = kopf(); return k ? Math.max(0, Math.round(k.getBoundingClientRect().bottom)) : 0; };
  const kopfOben = () => { const k = kopf(); return k ? Math.max(0, Math.round(k.getBoundingClientRect().top)) : 0; };

  // Unterpunkte am Handy klappen an Ort und Stelle auf, die Höhe wechselt weich (Familie Reaktion)
  const aufklappen = (root) => {
    root.querySelectorAll('.zlk-link--auf').forEach((b) => {
      b.addEventListener('click', () => {
        const box = document.getElementById(b.getAttribute('aria-controls'));
        if (!box) return;
        const auf = b.getAttribute('aria-expanded') !== 'true';
        b.setAttribute('aria-expanded', String(auf));
        if (ruhig()) { box.style.height = auf ? 'auto' : ''; box.classList.toggle('is-offen', auf); return; }
        const h = box.firstElementChild.getBoundingClientRect().height;
        const ende = (f) => box.addEventListener('transitionend', function e(ev) {
          if (ev.propertyName !== 'height') return;
          box.removeEventListener('transitionend', e);
          f();
        });
        if (auf) {
          box.classList.add('is-offen');
          box.style.height = '0px';
          requestAnimationFrame(() => { box.style.height = `${h}px`; });
          ende(() => { box.style.height = 'auto'; });
        } else {
          box.style.height = `${h}px`;
          requestAnimationFrame(() => { box.style.height = '0px'; });
          ende(() => { box.classList.remove('is-offen'); box.style.height = ''; });
        }
      });
    });
  };

  // Die Flasche unter Daumen oder Maus hebt sich wie aus dem Fach gegriffen.
  // Getippt: Diese Flasche bleibt oben, die anderen treten zurück, bis die neue Seite da ist.
  const reiheAnheben = (root) => {
    root.querySelectorAll('[data-zlk-reihe]').forEach((reihe) => {
      const sorten = [...reihe.querySelectorAll('.zlk-reihe__sorte')];
      let gewaehlt = null;
      let ablegen = 0;
      const naechste = (x) => {
        let best = null;
        let dist = Infinity;
        sorten.forEach((s) => {
          const r = s.getBoundingClientRect();
          const d = Math.abs(x - (r.left + r.width / 2));
          if (d < dist && x >= r.left - r.width * 0.2 && x <= r.right + r.width * 0.2) { dist = d; best = s; }
        });
        return best;
      };
      const heben = (s) => { if (!gewaehlt) sorten.forEach((t) => t.classList.toggle('is-oben', t === s)); };
      const alle = () => { if (!gewaehlt) sorten.forEach((t) => t.classList.remove('is-oben')); };
      reihe.addEventListener('pointerdown', (e) => { clearTimeout(ablegen); heben(naechste(e.clientX)); });
      reihe.addEventListener('pointermove', (e) => { if (e.pointerType !== 'touch' || e.buttons) heben(naechste(e.clientX)); });
      // Am Handy kommt nach dem Loslassen sofort pointerleave. Die Flasche bleibt oben, bis klar ist, ob getippt wurde.
      reihe.addEventListener('pointerleave', (e) => { if (e.pointerType !== 'touch') alle(); });
      reihe.addEventListener('pointerup', (e) => { if (e.pointerType === 'touch') ablegen = setTimeout(alle, 400); });
      reihe.addEventListener('pointercancel', alle);
      sorten.forEach((s) => s.addEventListener('click', (e) => {
        if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button > 0) return;
        clearTimeout(ablegen);
        gewaehlt = s;
        sorten.forEach((t) => { t.classList.toggle('is-oben', t === s); t.classList.toggle('is-gewaehlt', t === s); });
        reihe.classList.add('ist-gewaehlt');
        // Die neue Seite kommt oft schneller, als die anderen Flaschen ausblenden (vorgeladene Seiten), dann sieht man
        // die Wahl nicht. Deshalb geht die Seite erst, wenn das Ausblenden sichtbar ist (--zl-kopf-waehlen).
        if (ruhig() || !s.href) return;
        e.preventDefault();
        setTimeout(() => { window.location.href = s.href; }, ms('--zl-kopf-waehlen'));
      }));
      // Zurück-Button: wieder alles wie vorher
      window.addEventListener('pageshow', (e) => {
        if (!e.persisted) return;
        gewaehlt = null;
        reihe.classList.remove('ist-gewaehlt');
        sorten.forEach((t) => t.classList.remove('is-oben', 'is-gewaehlt'));
      });
    });
  };

  // ---------- Handy: Menü über dem Bildschirm ----------
  const handyMenu = () => {
    const box = document.getElementById('zlk-menu');
    if (!box) return;
    const grund = document.getElementById('zlk-menu-grund'); // die weiße Fläche unter den Einträgen (zl-kopf.css)
    const knoepfe = () => [...document.querySelectorAll('.js-toggle-slide-nav')];
    let offen = false;
    let schliesstTimer = 0;
    let zuletzt = null;

    // Alles auf einen Bildschirm (Moritz, 10.10.2026): Braucht das Menü mehr Höhe, als der Bildschirm hat, werden die
    // Flaschen kleiner, die Abstände bleiben. Unter der Grundlinie des letzten Eintrags bleibt der Innenrand einer
    // Fläche (18) frei, die Tippfläche darf ihn füllen. Unter --zl-kopf-flasche-min wird gescrollt.
    // Gemessen am Layout (offsetTop), weil die Einträge beim Öffnen noch verschoben sind.
    const innen = box.querySelector('.zlk-menu__innen');
    const passen = () => {
      const flasche = box.querySelector('.zlk-reihe__flasche');
      if (!innen || !flasche) return;
      box.style.removeProperty('--zlk-flasche-max');
      const punkte = box.querySelectorAll('.zlk-menu__punkt');
      const letzte = punkte[punkte.length - 1];
      const wort = letzte && letzte.querySelector('.zlk-wort-text');
      if (!wort) return;
      const zeile = letzte.getBoundingClientRect();
      const text = wort.getBoundingClientRect();
      const fs = parseFloat(getComputedStyle(wort).fontSize) || 0;
      const grundlinie = text.bottom - (text.height - fs) / 2 - 0.2 * fs; // Unterlänge der Schrift 0,2 em
      const zuviel = letzte.offsetTop + (grundlinie - zeile.top) + ms('--zl-gap-pair') - box.clientHeight;
      if (zuviel <= 0) return;
      const h = flasche.getBoundingClientRect().height;
      box.style.setProperty('--zlk-flasche-max', `${Math.max(ms('--zl-kopf-flasche-min'), Math.floor(h - zuviel))}px`);
    };
    // Das erste Öffnen soll so schnell sein wie jedes weitere (Moritz, 11.10.2026): Was das Menü sonst beim ersten Tippen
    // erledigt (Bilder der Flaschen laden und entpacken, die Höhe einpassen), passiert vorher, sobald die Seite Ruhe hat.
    // Beim Öffnen wird nur neu eingepasst, wenn sich Bildschirm oder Kopf seitdem geändert haben.
    let passtFuer = '';
    let lageWar = '';
    const lage = () => {
      const unten = kopfUnten();
      const oben = kopfOben();
      const k = `${window.innerWidth}x${window.innerHeight}x${unten}x${oben}`;
      // Nur schreiben, was sich geändert hat: Jede Änderung an der Fläche kostet den Browser im Moment des Tippens Zeit
      if (k !== lageWar) {
        lageWar = k;
        [box, grund].forEach((el) => {
          if (!el) return;
          el.style.setProperty('--zlk-top', `${unten}px`);
          el.style.setProperty('--zlk-oben', `${oben}px`);
        });
      }
      return k;
    };
    const passenWenn = () => { const k = lage(); if (k === passtFuer) return; passtFuer = k; passen(); };
    const vorwaermen = () => {
      if (!handy() || offen) return;
      ['--zl-kopf-tipp-weg', '--zl-kopf-tipp-sperre', '--zl-kopf-menu-dauer', '--zl-kopf-menu-zu', '--zl-kopf-menu-nachlauf', '--zl-kopf-menu-start', '--zl-kopf-menu-staffel-handy', '--zl-kopf-menu-eintrag'].forEach(tok);
      box.querySelectorAll('img').forEach((i) => { i.loading = 'eager'; if (i.decode) i.decode().catch(() => {}); });
      passenWenn();
    };
    // Safari kennt requestIdleCallback nicht und meldet das Ende des Ladens auf der Startseite erst spät (Show, Filme, 3D).
    // Deshalb dort spätestens nach --zl-kopf-vorwaermen, unabhängig vom Laden.
    let gewaermt = false;
    const einmalWaermen = () => { if (gewaermt) return; gewaermt = true; vorwaermen(); };
    if ('requestIdleCallback' in window) window.requestIdleCallback(einmalWaermen, { timeout: tok('--zl-kopf-vorwaermen') });
    else {
      window.addEventListener('load', einmalWaermen);
      setTimeout(einmalWaermen, tok('--zl-kopf-vorwaermen'));
    }
    window.addEventListener('resize', () => { if (offen) { passtFuer = lage(); passen(); } }, { passive: true });
    if (window.visualViewport) window.visualViewport.addEventListener('resize', () => { if (offen) { passtFuer = lage(); passen(); } });

    // Im Moment des Tippens passiert nur, was die Bewegung startet (Moritz, 11.10.2026: das erste Öffnen ruckelte, gemessen
    // am iPhone).
    // - Der Zustand (zlk-offen, zlk-schliesst) hängt am Bereich des Kopfs, nicht an html: Eine Klasse an html ließ Safari
    //   auf der Startseite alle Regeln der Show neu prüfen.
    // - Fokus auf den ersten Eintrag und das Anhalten der Show (Ereignis zl-menu) kommen erst, wenn alle Einträge stehen;
    //   das Weiterlaufen der Show erst, wenn die Fläche ganz zu ist. So fällt keine Arbeit in eine Bewegung.
    // - Die Seite dahinter wird nicht über overflow am body festgehalten (das ließ Safari die ganze Seite neu setzen), das
    //   Menü ist dafür immer um 1 px scrollbar und hält das Scrollen bei sich (zl-kopf.css, .zlk-menu__innen).
    // - Das Feld des Newsletters wird direkt versteckt, nicht über eine Regel, die jedes Element der Seite prüfen müsste.
    const zustand = box.closest('.shopify-section') || html;
    let fertigTimer = 0;
    const newsletter = (weg) => {
      document.querySelectorAll('[class*="kl-teaser-"]').forEach((el) => {
        if (weg) { el.style.setProperty('visibility', 'hidden', 'important'); el.style.setProperty('pointer-events', 'none', 'important'); }
        else { el.style.removeProperty('visibility'); el.style.removeProperty('pointer-events'); }
      });
    };
    const melden = (wert) => document.dispatchEvent(new CustomEvent('zl-menu', { detail: { offen: wert } }));
    // Den Fokus verschiebt das Menü nur, wenn es mit der Tastatur geöffnet wurde (taste = true). Nach einem Tipp mit dem
    // Finger oder einem Klick mit der Maus galt der verschobene Fokus als Tastatur-Fokus: Der Kopf über der Show blieb
    // nach dem Schließen weiß, weil er bei Tastatur-Fokus weiß wird (Moritz, 11.10.2026, Chrome am iPhone).
    let perTaste = false;
    const setzen = (wert, taste = false) => {
      if (wert === offen) return;
      if (wert) perTaste = taste;
      clearTimeout(schliesstTimer);
      clearTimeout(fertigTimer);
      if (!wert) {
        // Der Kopf geht mit der Fläche zurück, solange sie fährt (zl-kopf.css)
        zustand.classList.add('zlk-schliesst');
        schliesstTimer = setTimeout(() => {
          zustand.classList.remove('zlk-schliesst');
          newsletter(false);
          melden(false);
        }, tok('--zl-kopf-menu-zu') + tok('--zl-kopf-menu-nachlauf'));
      } else {
        zustand.classList.remove('zlk-schliesst');
        passenWenn();
        if (box.scrollTop) box.scrollTop = 0;
        newsletter(true);
        const punkte = box.querySelectorAll('.zlk-menu__punkt').length;
        const stehen = Math.max(tok('--zl-kopf-menu-dauer'), tok('--zl-kopf-menu-start') + tok('--zl-kopf-menu-staffel-handy') * Math.max(0, punkte - 1) + tok('--zl-kopf-menu-eintrag'));
        fertigTimer = setTimeout(() => {
          if (!offen) return;
          melden(true);
          if (!perTaste) return;
          const erstes = box.querySelector('a, button');
          if (erstes) erstes.focus({ preventScroll: true });
        }, stehen);
      }
      offen = wert;
      zustand.classList.toggle('zlk-offen', wert);
      box.setAttribute('aria-hidden', String(!wert));
      if (!wert) box.setAttribute('inert', ''); else box.removeAttribute('inert');
      knoepfe().forEach((t) => t.setAttribute('aria-expanded', String(wert)));
      if (!wert && box.contains(document.activeElement)) {
        if (perTaste && zuletzt) zuletzt.focus({ preventScroll: true });
        else document.activeElement.blur();
      }
    };

    // Finger: Das Menü öffnet, sobald der Finger den Knopf loslässt, nicht erst mit dem Klick, den Safari danach schickt.
    // Den Klick hält Safari zurück, bis es geprüft hat, ob der Tipp etwas anderes meint; beim ersten Tipp auf einer
    // Seite dauert das spürbar länger (Moritz, 11.10.2026: das erste Öffnen kam verzögert, jedes weitere sofort).
    // Ein Tipp ist es nur, wenn der Finger kaum gewandert ist; der Klick danach wird verworfen.
    let fingerAuf = null;
    let fingerZu = 0;
    window.addEventListener('touchstart', (e) => {
      const t = e.target.closest && e.target.closest('.js-toggle-slide-nav');
      fingerAuf = t && e.touches.length === 1 ? { t, x: e.touches[0].clientX, y: e.touches[0].clientY } : null;
      if (fingerAuf) ['--zl-kopf-tipp-weg', '--zl-kopf-tipp-sperre', '--zl-kopf-menu-dauer'].forEach(tok);
    }, { capture: true, passive: true });
    window.addEventListener('touchend', (e) => {
      const f = fingerAuf;
      fingerAuf = null;
      if (!f || !box.isConnected || !handy()) return;
      const p = e.changedTouches[0];
      if (!p || Math.hypot(p.clientX - f.x, p.clientY - f.y) > tok('--zl-kopf-tipp-weg')) return;
      e.preventDefault(); // kein Klick von Safari hinterher
      fingerZu = performance.now();
      zuletzt = f.t;
      setzen(!offen);
    }, { capture: true, passive: false });

    // Maus, Tastatur und alles ohne Finger: der Klick. Der Knopf im Kopf öffnet dieses Menü statt der Seitenleiste des Themes.
    window.addEventListener('click', (e) => {
      if (!box.isConnected) return; // Theme-Editor hat den Kopf neu geladen, der neue Aufbau übernimmt
      const t = e.target.closest && e.target.closest('.js-toggle-slide-nav');
      if (!t) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      if (performance.now() - fingerZu < tok('--zl-kopf-tipp-sperre')) return; // schon beim Loslassen geöffnet
      zuletzt = t;
      setzen(!offen, e.detail === 0); // detail 0: mit Enter oder Leertaste ausgelöst, nicht mit der Maus
    }, true);
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && offen && box.isConnected) setzen(false, true); });
    // Tastatur bleibt im offenen Menü: zwischen dem Knopf im Kopf und den Einträgen, nicht in der Seite dahinter
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Tab' || !offen || !box.isConnected) return;
      const liste = [...box.querySelectorAll('a[href], button:not([disabled])')].filter((el) => el.getBoundingClientRect().width > 0);
      const knopf = zuletzt || knoepfe().find((t) => t.getBoundingClientRect().width > 0);
      if (!liste.length || !knopf) return;
      const jetzt = document.activeElement;
      let ziel = null;
      if (!e.shiftKey && jetzt === knopf) ziel = liste[0];
      else if (!e.shiftKey && jetzt === liste[liste.length - 1]) ziel = knopf;
      else if (e.shiftKey && jetzt === liste[0]) ziel = knopf;
      else if (e.shiftKey && jetzt === knopf) ziel = liste[liste.length - 1];
      else if (!box.contains(jetzt)) ziel = liste[0];
      if (ziel) { e.preventDefault(); ziel.focus(); }
    });
    // Wird das Fenster breiter, gelten die Einträge im Kopf
    window.addEventListener('resize', () => { if (offen && !handy()) setzen(false); }, { passive: true });
    // Zurück-Button: Menü zu
    window.addEventListener('pageshow', (e) => { if (e.persisted) setzen(false); });

    aufklappen(box);
    reiheAnheben(box);
  };

  // ---------- Desktop: Einträge im Kopf, Fläche darunter ----------
  const desktop = () => {
    const nav = document.getElementById('zlk-nav');
    const panel = document.getElementById('zlk-panel');
    if (!nav || !panel) return;
    const rahmen = panel.querySelector('.zlk-panel__rahmen');
    let aktiv = null;
    let zuTimer = 0;
    let fahrtTimer = 0;
    let perKlick = false;
    let letzterFinger = 0;
    // Nummer jedes Eintrags in seiner Fläche, für das Rollen beim Öffnen und Schließen (zl-kopf.css)
    panel.querySelectorAll('.zlk-panel__teil').forEach((t) => {
      const eintraege = t.querySelectorAll('.zlk-panel__spalte > :not(.zlk-panel__service), .zlk-panel__service > *');
      t.style.setProperty('--zlk-gesamt', eintraege.length);
      eintraege.forEach((el, i) => el.style.setProperty('--zlk-n', i));
    });

    const zeig = (id) => {
      clearTimeout(zuTimer);
      const teil = panel.querySelector(`[data-teil="${id}"]`);
      const knopf = nav.querySelector(`[data-fuer="${id}"]`);
      if (!teil || !knopf) return;
      // Inhalt steht linksbündig an der Kante des Logos, egal unter welchem Eintrag er aufgeht (Moritz, 09.10.2026)
      const logo = document.querySelector('.site-header .header-item--logo');
      panel.style.setProperty('--zlk-spalte-x', `${Math.round(logo ? logo.getBoundingClientRect().left : 0)}px`);
      html.style.setProperty('--zlk-top', `${kopfUnten()}px`);
      nav.querySelectorAll('[data-fuer]').forEach((b) => b.setAttribute('aria-expanded', String(b === knopf)));
      const war = aktiv;
      aktiv = id;
      panel.querySelectorAll('.zlk-panel__teil').forEach((t) => t.classList.toggle('is-aktiv', t === teil));
      rahmen.style.height = `${teil.getBoundingClientRect().height}px`;
      panel.classList.toggle('ist-wechsel', !!war && war !== id);
      clearTimeout(fahrtTimer);
      html.classList.remove('zlk-panel-schliesst');
      panel.classList.add('is-offen');
      html.classList.add('zlk-panel-offen');
    };
    const zu = (sofort) => {
      clearTimeout(zuTimer);
      const f = () => {
        // Solange die Fläche hochfährt, gehört der Kopf noch zu ihr (zl-kopf.css, über dem Teaser bleibt er so lange weiß)
        if (aktiv) {
          html.classList.add('zlk-panel-schliesst');
          clearTimeout(fahrtTimer);
          fahrtTimer = setTimeout(() => html.classList.remove('zlk-panel-schliesst'), tok('--zl-kopf-menu-zu') + tok('--zl-kopf-menu-nachlauf'));
        }
        aktiv = null;
        perKlick = false;
        panel.classList.remove('is-offen', 'ist-wechsel');
        html.classList.remove('zlk-panel-offen');
        nav.querySelectorAll('[data-fuer]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
      };
      if (sofort) f(); else zuTimer = setTimeout(f, 160);
    };

    // Maus: Überfahren öffnet. Ein Klick auf einen schon offenen Eintrag schließt nur, wenn er per Klick, Finger oder
    // Tastatur offen ist, sonst bliebe nach dem Überfahren und Klicken nichts offen. Finger lösen kein Überfahren aus.
    // Tastatur: Fokus allein öffnet nichts, Enter oder Leertaste öffnen (Klick des Knopfs).
    nav.addEventListener('pointerdown', (e) => { if (e.pointerType !== 'mouse') letzterFinger = Date.now(); });
    nav.querySelectorAll('[data-fuer]').forEach((b) => {
      b.addEventListener('mouseenter', () => {
        if (Date.now() - letzterFinger < 800) return;
        if (aktiv !== b.dataset.fuer) perKlick = false;
        zeig(b.dataset.fuer);
      });
      b.addEventListener('click', () => {
        if (aktiv === b.dataset.fuer && perKlick) { zu(true); perKlick = false; return; }
        perKlick = true;
        zeig(b.dataset.fuer);
      });
    });
    // Tastatur: Die Fläche liegt im Code hinter dem Kopf. Tab führt vom offenen Eintrag in seine Fläche,
    // vom letzten Link der Fläche zum nächsten Element im Kopf, Shift-Tab vom ersten Link zurück zum Eintrag.
    const fokussierbar = (root) => [...root.querySelectorAll('a[href], button:not([disabled])')].filter((e) => e.getBoundingClientRect().width > 0);
    nav.querySelectorAll('[data-fuer]').forEach((b) => b.addEventListener('keydown', (e) => {
      if (e.key !== 'Tab' || e.shiftKey || aktiv !== b.dataset.fuer) return;
      const erste = fokussierbar(panel.querySelector('.zlk-panel__teil.is-aktiv') || panel)[0];
      if (!erste) return;
      e.preventDefault();
      erste.focus();
    }));
    panel.addEventListener('keydown', (e) => {
      if (e.key !== 'Tab' || !aktiv) return;
      const knopf = nav.querySelector(`[data-fuer="${aktiv}"]`);
      const liste = fokussierbar(panel.querySelector('.zlk-panel__teil.is-aktiv') || panel);
      if (e.shiftKey && document.activeElement === liste[0]) {
        e.preventDefault();
        knopf.focus();
      } else if (!e.shiftKey && document.activeElement === liste[liste.length - 1]) {
        const kopfListe = fokussierbar(kopf() || document.body);
        const naechstes = kopfListe[kopfListe.indexOf(knopf) + 1];
        if (!naechstes) return;
        e.preventDefault();
        naechstes.focus();
      }
    });
    nav.querySelectorAll('a.zlk-nav__punkt').forEach((a) => {
      a.addEventListener('mouseenter', () => zu());
      a.addEventListener('focus', () => zu(true));
    });
    nav.addEventListener('mouseleave', () => zu());
    panel.addEventListener('mouseenter', () => clearTimeout(zuTimer));
    panel.addEventListener('mouseleave', () => zu());
    // Fokus verlässt Kopf und Fläche: Fläche zu
    document.addEventListener('focusin', (e) => {
      if (!nav.isConnected) return;
      if (aktiv && !nav.contains(e.target) && !panel.contains(e.target)) zu(true);
    });
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape' || !aktiv || !nav.isConnected) return;
      const knopf = nav.querySelector(`[data-fuer="${aktiv}"]`);
      zu(true);
      if (knopf && panel.contains(document.activeElement)) knopf.focus({ preventScroll: true });
    });
    window.addEventListener('scroll', () => { if (aktiv) html.style.setProperty('--zlk-top', `${kopfUnten()}px`); }, { passive: true });
    window.addEventListener('pageshow', (e) => { if (e.persisted) zu(true); });

    reiheAnheben(panel);
  };

  const start = () => {
    html.classList.toggle('zlk-an', !!document.getElementById('zlk-menu'));
    handyMenu();
    desktop();
  };
  // Theme-Editor: Lädt er den Kopf neu, wird das Menü neu aufgebaut
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target && e.target.querySelector && e.target.querySelector('#zlk-menu, #zlk-nav')) start();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
